import axios from 'axios';
import { LOGGEDIN_USER_DATA } from 'global_config/constant-global';

export const AUDIT_TRAIL_BASE_PATH = 'system/auditTrail';

const auditTrailUrl = `${process.env.REACT_APP_BACKEND_API}${AUDIT_TRAIL_BASE_PATH}`;
const auditLogAxios = axios.create();

export function getSessionUserData() {
    try {
        const rawValue = sessionStorage.getItem(LOGGEDIN_USER_DATA);
        return rawValue ? JSON.parse(rawValue) : null;
    } catch (error) {
        return null;
    }
}

function resolveSessionUserID(userData) {
    if (!userData) return null;
    return userData.userID || userData.user_id || userData.id || null;
}

export function isRootSessionUser() {
    const userData = getSessionUserData();
    const roleName = userData && (userData.roleName || userData.role_name || '');

    return String(roleName).toUpperCase() === 'ROOT';
}

export async function searchAuditTrailAPI(filters = {}) {
    const userData = getSessionUserData();
    const requesterUserID = resolveSessionUserID(userData);

    const params = Object.keys(filters).reduce((acc, key) => {
        const value = filters[key];

        if (value !== undefined && value !== null && value !== '') {
            acc[key] = value;
        }

        return acc;
    }, {});
    params.requesterUserID = requesterUserID;

    const response = await axios({
        method: 'GET',
        url: `${auditTrailUrl}/search`,
        params,
        headers: {
            'content-type': 'application/json',
        },
    });

    return response.data;
}

export async function fetchAuditTrailFilterLovAPI(filters = {}) {
    const userData = getSessionUserData();
    const requesterUserID = resolveSessionUserID(userData);
    const moduleCode = filters && filters.moduleCode ? filters.moduleCode : '';

    const response = await axios({
        method: 'GET',
        url: `${auditTrailUrl}/filterLov`,
        params: {
            requesterUserID,
            moduleCode,
        },
        headers: {
            'content-type': 'application/json',
        },
    });

    return response.data;
}

export async function sendAuditTrailLog(payload) {
    if (!payload) return null;

    try {
        const response = await auditLogAxios({
            method: 'POST',
            url: `${auditTrailUrl}/create`,
            data: payload,
            headers: {
                'content-type': 'application/json',
            },
        });

        return response.data;
    } catch (error) {
        if (process.env.NODE_ENV !== 'production') {
            // Keep audit logging fail-safe but visible in local dev.
            console.error('sendAuditTrailLog failed', error && error.response ? error.response : error);
        }
        return null;
    }
}

function safeJsonStringify(value) {
    try {
        return JSON.stringify(value);
    } catch (error) {
        return JSON.stringify({ note: 'UNSERIALIZABLE_PAYLOAD' });
    }
}

function truncateText(value, maxLength = 3900) {
    const text = String(value || '');
    return text.length > maxLength ? `${text.slice(0, maxLength)}...` : text;
}

export async function logAuditTrailEvent({
    moduleCode = 'sys',
    subModuleCode = '',
    activityCode = '',
    action = 'ACTION',
    description = '',
    payload = {},
    isSuccess = 1,
    createdBy,
} = {}) {
    const userData = getSessionUserData();
    const created_by = createdBy || resolveSessionUserID(userData);

    if (!created_by) return null;

    const normalizedModuleCode = String(moduleCode || 'sys').toLowerCase().slice(0, 50);
    const normalizedSubModuleCode = subModuleCode ? String(subModuleCode).toLowerCase().slice(0, 50) : null;
    const normalizedAction = String(action || 'ACTION').toUpperCase().replace(/[^A-Z0-9_]/g, '_').slice(0, 40);
    const generatedActivityCode = `${normalizedAction}_${normalizedModuleCode}`.slice(0, 50);
    const parameters = truncateText(safeJsonStringify(payload), 3900);
    const desc = truncateText(
        description || `${normalizedAction} on ${normalizedModuleCode}${normalizedSubModuleCode ? `/${normalizedSubModuleCode}` : ''}`,
        3900,
    );

    return sendAuditTrailLog({
        module_code: normalizedModuleCode,
        sub_module_code: normalizedSubModuleCode,
        activity_code: (activityCode || generatedActivityCode).slice(0, 50),
        is_success: isSuccess ? 1 : 0,
        description: desc,
        parameters,
        created_by,
    });
}
